import React from 'react';
import PropTypes from 'prop-types';

import { Col, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';

import { CONTENT_VERIFICATION_STATUS_OPTIONS } from 'lib/enums/ContentVerificationStatus';

const ARCHIVED_STATUS_OPTIONS = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

const CLIENT_PRODUCT_STATUS_OPTIONS = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'INACTIVE' },
];

function DataSourceEditTabFlagUpdateImportTypeOptions({ metaData, setMetaData }) {
  return (
    <>
      <Form.Group className="d-flex align-items-center" as={Row}>
        <Form.Label column>
          Update content verification status
          <OverlayTrigger
            overlay={
              <Tooltip>Whether to update the content verification status on products</Tooltip>
            }
            placement="top"
            delayShow={300}
            delayHide={150}
          >
            <FontAwesomeIcon icon={faInfoCircle} className="ml-2" />
          </OverlayTrigger>
        </Form.Label>
        <Col md={7}>
          <Select
            isClearable
            value={
              CONTENT_VERIFICATION_STATUS_OPTIONS.filter(
                op => op.value === metaData.verify_content_status,
              ) || null
            }
            options={CONTENT_VERIFICATION_STATUS_OPTIONS}
            onChange={option => {
              setMetaData({ ...metaData, verify_content_status: option?.value || null });
            }}
          />
        </Col>
      </Form.Group>
      <Form.Group className="d-flex align-items-center" as={Row}>
        <Form.Label column>
          Update archive status
          <OverlayTrigger
            overlay={
              <Tooltip>
                Whether to mark the product as archived or not. (this is not the active_status field
                of product)
              </Tooltip>
            }
            placement="top"
            delayShow={300}
            delayHide={150}
          >
            <FontAwesomeIcon icon={faInfoCircle} className="ml-2" />
          </OverlayTrigger>
        </Form.Label>
        <Col md={7}>
          <Select
            isClearable
            value={ARCHIVED_STATUS_OPTIONS.find(op => op.value === metaData.archive_status) || null}
            options={ARCHIVED_STATUS_OPTIONS}
            onChange={option => {
              setMetaData({
                ...metaData,
                archive_status: option?.value !== undefined ? option.value : null,
              });
            }}
          />
        </Col>
      </Form.Group>
      <Form.Group className="d-flex align-items-center" as={Row}>
        <Form.Label column>
          Set Client side product status
          <OverlayTrigger
            overlay={
              <Tooltip>
                Updates the product status flag of the client. ex C+D. (This flag is only applied
                for the manufacturer products as the moment.)
              </Tooltip>
            }
            placement="top"
            delayShow={300}
            delayHide={150}
          >
            <FontAwesomeIcon icon={faInfoCircle} className="ml-2" />
          </OverlayTrigger>
        </Form.Label>
        <Col md={7}>
          <Select
            isClearable
            value={
              CLIENT_PRODUCT_STATUS_OPTIONS.find(
                op => op.value === metaData.client_product_status,
              ) || null
            }
            options={CLIENT_PRODUCT_STATUS_OPTIONS}
            onChange={option => {
              setMetaData({
                ...metaData,
                client_product_status: option?.value !== undefined ? option.value : null,
              });
            }}
          />
        </Col>
      </Form.Group>
    </>
  );
}

DataSourceEditTabFlagUpdateImportTypeOptions.propTypes = {
  metaData: PropTypes.object.isRequired,
  setMetaData: PropTypes.func.isRequired,
};

export default DataSourceEditTabFlagUpdateImportTypeOptions;
